exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".b-btn__icon[data-v-87ca352a]{color:#8a8a8a!important}.icon-arrow_back-navbar[data-v-87ca352a]{fill:#aaa;height:24px;width:24px}.b-page[data-v-87ca352a]{background:#292929}.w-navbar[data-v-87ca352a]{background-color:#292929}.w-navbar .text[data-v-87ca352a]{color:#fff;text-transform:none}", ""]);

// exports
